/* unplugin-vue-components disabled */import { render } from "./Countdown.vue?vue&type=template&id=4d495643&scoped=true"
import script from "./Countdown.vue?vue&type=script&lang=js"
export * from "./Countdown.vue?vue&type=script&lang=js"

import "./Countdown.vue?vue&type=style&index=0&id=4d495643&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d495643"]])

export default __exports__